import React, { useState, useCallback } from 'react';
import { Box } from '@rsos/base-components';
import { PORTAL_LIGHTBOX_PRIORITY } from '@rsos/capstone/src/constants/portalPriorities';
import Modal from '@rsos/components/capstone/base/Modal';
import EllingtonCardList from '../../../AdditionalData/EllingtonCardList';
import CollaboratorBanner from './CollaboratorBanner';

export const DataCards = ({
  summarized = false,
  onActionableButton = () => {},
  onClick = () => {},
}) => {
  const [isActive, setIsActive] = useState(false);
  const [zoomedURL, setZoomedURL] = useState('');

  const handleZoom = useCallback((imageURL = '') => {
    setZoomedURL(imageURL);
    setIsActive(prev => !prev);
  }, []);

  return (
    <>
      <Modal
        id="card-image-modal"
        className="card-image-modal"
        portalPriority={PORTAL_LIGHTBOX_PRIORITY}
        isOpened={isActive}
        onClose={() => {
          setZoomedURL('');
          setIsActive(false);
        }}
        width="75%"
      >
        <img
          className="default-type-string-format-image-actual"
          src={zoomedURL}
        />
      </Modal>
      {!summarized && (
        <Box mb="16px">
          <CollaboratorBanner />
        </Box>
      )}
      <EllingtonCardList
        summarized={summarized}
        noPadding
        onZoom={handleZoom}
        onActionableButton={onActionableButton}
        onClick={onClick}
        isUniteEventPaneEnabled
      />
    </>
  );
};

export default React.memo(DataCards);
